import React, { ChangeEvent } from 'react';
import { SearchInput } from '../../../atoms/Inputs/SearchInput';
import { IconLabel } from '../../../atoms/Texts/IconLabel';

interface SearchProductProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const SearchProduct = ({ value, onChange }: SearchProductProps) => {
  return (
    <div>
      <IconLabel icon={'Search'} label={'Rechercher un produit'} />
      <SearchInput
        value={value}
        placeHolder={'Cookies bio...'}
        onChange={onChange}
      />
    </div>
  );
};
